export default __webpack_public_path__ + "static/ds-zeroheight-design-tokens-3b6c4214233cd44c8d453d19fa1ea8ce.png";